import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { withTranslation } from "react-i18next";
import Modal from "react-modal";
import { toast } from "react-toastify";
import classNames from "classnames";
import "./index.scss";

import {
  ORDER_DELETE,
  PERFORM_ORDER_ASSOCIATING,
  ORDER_ASSISTANCE_DELETE,
  RELOAD_ORDER,
  actionUpdateOrderData,
  CHANGE_ORDER_STATE,
  LOAD_HISTORY_ORDERS,
  SET_ORDER_DELIVERED_BY,
  NEW_GROUP_REORDER
} from "../../../store/reducers/order/order-actions";
import { actionSaveSectionItemHeight, actionSetSectionItemsLoading } from "../../../store/reducers/sectionsWrapperData/sectionsWrapperData-actions";
import {
  ADD_ORDER_TO_EXTERNAL_CYCLE,
  ASSOCIATE_ORDER_TO_EXTERNAL_CYCLE,
} from '../../../store/reducers/externalCycles/externalCycles-actions';

import { isDepotMode, isAutoMode } from "../../../services/restaurant";
import { getConvertedTargetTime, isAssistanceGroup, isDefaultGroup } from "../../../services/order";
import { currentUserIsDepotRole, getUserByOrder } from "../../../services/userModel";

import { createAction } from "../../../utils/sagaHelper";
import {
  ORDER_STATE,
  ORDER_TYPE,
  DEFAULT_ORDERS_GROUPS,
  CONFIRM_DIALOG_TYPE,
  CYCLE_STATE
} from "../../../utils/enums";
import {
  ordersRowHeightDefault,
  ordersRowHeightExpand,
  activeOrderRowWidthResize,
  ordersRowHeightExpandResize,
  ordersRowHeightDefaultResize,
  NEW_ASSOCIATE_GROUP_ID
} from "../../../utils/constants";
import { isSameObjects } from "../../../utils/objects-util";

import AssociatePopup from "../../containers/AssociatePopupContainer";
import ActiveOrderInfo from "./activeOrderInfo";
import ActiveOrderInfoMore from "./activeOrderInfoMore";

const userInfoItem = (leftSide, rightSide, useClass, key) => {
  return (
    <div key={key || `userInfoItem-${Math.random()}-${Math.random()}`}
      className={classNames("userInfoItem", useClass || "")}
    >
      <div className={classNames("centerSide")}>{leftSide}</div>
      <div className={classNames("rightSide")}>{rightSide}</div>
    </div>
  );
};

class ActiveOrder extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showOrdersMore: props.sectionItemsHeights[props.item.id] === (
        window.innerWidth <= activeOrderRowWidthResize ? ordersRowHeightExpandResize : ordersRowHeightExpand 
      ) || false,
      showConfirmDialog: false,
      courierConfirmDialogType: null,
      showAssociatePopup: false,
      isWithPassword: true,
      isEditDelivery: false
    };
  }

  componentDidMount() {
    const {
      item,
      groups,
      users,
      saveSectionItemHeight,
      sectionItemsHeights
    } = this.props;
    this.user = getUserByOrder(users, item);
    this.group = groups.find(group => group.id === item.groupId);

    if (!sectionItemsHeights[item.id]) {
      saveSectionItemHeight({
        id: item.id,
        height: window.innerWidth <= activeOrderRowWidthResize ? ordersRowHeightDefaultResize + 10 : ordersRowHeightDefault
      });
    }

    window.addEventListener("resize", this.handleOnResize);
  }

  shouldComponentUpdate(nextProps, nextState) {
    const { item, users } = this.props;
    const {
      showOrdersMore,
      showConfirmDialog,
      showAssociatePopup,
      isWithPassword,
      isEditDelivery
    } = this.state;

    return item !== nextProps.item ||
      showOrdersMore !== nextState.showOrdersMore ||
      showConfirmDialog !== nextState.showConfirmDialog ||
      showAssociatePopup !== nextState.showAssociatePopup ||
      isWithPassword !== nextState.isWithPassword ||
      isEditDelivery !== nextState.isEditDelivery ||
      (item && !isDefaultGroup(item.groupId) && (!this.user || !isSameObjects(this.user, (users || []).find(user => user.id === item.groupId))))
  }

  componentDidUpdate(prevProps, prevState) {
    const { item } = this.props;
    const { showOrdersMore } = this.state;

    if (
      showOrdersMore !== prevState.showOrdersMore ||
      item.id !== prevProps.item.id
    ) {
      this.updateRowHeight(prevProps.item.id);
    }
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleOnResize);
  }

  updateRowHeight = prevId => {
    const { item, saveSectionItemHeight, sectionItemsHeights } = this.props;
    const { showOrdersMore } = this.state;
    const isResize = window.innerWidth <= activeOrderRowWidthResize;
    const rowHeight = prevId && item.id !== prevId
      ? sectionItemsHeights[item.id] || (isResize ? ordersRowHeightDefaultResize + 10 : ordersRowHeightDefault)
      : showOrdersMore
        ? (isResize ? ordersRowHeightExpandResize : ordersRowHeightExpand)
        : (isResize ? ordersRowHeightDefaultResize + 10 : ordersRowHeightDefault);
    const showMore = (rowHeight === ordersRowHeightExpand || rowHeight === ordersRowHeightExpandResize);

    if (showOrdersMore !== showMore) {
      this.setState({
        showOrdersMore: showMore
      });
    }

    if (rowHeight !== sectionItemsHeights[item.id]) {
      saveSectionItemHeight({
        id: item.id,
        height: rowHeight
      });
    }
  }

  getOrderStatusLabeltext = () => {
    const { t, item } = this.props;

    switch (item.state) {
      case ORDER_STATE.new:
        return t("orders.PENDING_STATUS_LABEL");
      case ORDER_STATE.kitchen:
        return t("orders.COOKING_STATUS_LABEL");
      case ORDER_STATE.ready:
        switch (item.type) {
          case ORDER_TYPE.delivery:
            return t("orders.READY_DELIVERY_STATUS_LABEL");
          case ORDER_TYPE.takeAway:
            return t("orders.READY_TAKEAWAY_STATUS_LABEL");
          default:
            return "";
        }
      case ORDER_STATE.onroute:
        return t("orders.DISPATCHED_STATUS_LABEL");
      case ORDER_STATE.delivered:
        return t("orders.CLOSED_STATUS_LABEL");
      case ORDER_STATE.canceled:
        return t("orders.DELETED_STATUS_LABEL");
      default:
        return "";
    }
  };

  getIsShowAssociate = () => {
    const { item, restaurant } = this.props;

    if(this.getIsShowPickedUp()){
      return false
    }

    return (
      !currentUserIsDepotRole() &&
      (item.groupId !== DEFAULT_ORDERS_GROUPS.takeawayOrders || item.state !== ORDER_STATE.ready || item.type !== ORDER_TYPE.takeAway) &&
      (!isAutoMode(restaurant) &&
        (!this.user || !this.user.cycle || this.user.cycle.state === CYCLE_STATE.started)
      )
    );
  };

  getIsShowPickedUp = () => {
    const { item } = this.props;

    return item && item.state === ORDER_STATE.ready && item.type === ORDER_TYPE.takeAway;
  }

  getIsShowReady = () => {
    const { item, restaurant } = this.props;

    return (
      (item.groupId !== DEFAULT_ORDERS_GROUPS.takeawayOrders ||
        item.state !== ORDER_STATE.ready) &&
      (isAutoMode(restaurant) ||
        (this.user && this.user.cycle && this.user.cycle.state > 0))
    );
  };

  getHistoryOrders = (clearHistory, hours, date) => {
    const {
      orders,
      loadHistoryOrders,
      historyOrders,
      sectionModel,
      setSectionItemsLoading
    } = this.props;
    setSectionItemsLoading(true);
    loadHistoryOrders({
      ordersFilterModel: sectionModel.filterOptions,
      activeOrders: orders,
      historyOrders: historyOrders,
      clearHistory: clearHistory,
      hours: hours,
      date: date
    }).then(
      () => {
        setSectionItemsLoading(false);
      },
      () => {
        setSectionItemsLoading(false);
      }
    );
  };

  getHeight = () => {
    const { showOrdersMore } = this.state;
    return showOrdersMore ? ordersRowHeightDefault : ordersRowHeightExpand;
  };

  handleOnRevertClick = () => {
    this.setState({
      courierConfirmDialogType: CONFIRM_DIALOG_TYPE.deleteItem,
      showConfirmDialog: true
    });
  };

  handleOnShowConfirmDialog = (type, isWithPassword = true) => {
    this.setState({
      courierConfirmDialogType: type,
      showConfirmDialog: true,
      isWithPassword: isWithPassword
    });
  };

  handleOnPreviewClick = () => {
    return new Promise(resolve => {
      this.handleOnEdit();
      resolve();
    });
  };

  handleOnConfirmDialog = token => {
    const { courierConfirmDialogType } = this.state;
    const {
      t,
      item,
      deleteAssistanceOrder,
      deleteOrder,
      reloadOrder
    } = this.props;

    return new Promise((resolve, reject) => {
      switch (courierConfirmDialogType) {
        case CONFIRM_DIALOG_TYPE.deleteItem:
          if (isAssistanceGroup(item.groupId)) {
            deleteAssistanceOrder({ order: item }).then(
              () => {
                resolve();
                this.handleOnCancelConfirmDialog();
              },
              () => {
                reject();
                this.handleOnCancelConfirmDialog();
              }
            );
          } else {
            deleteOrder({ order: item, token: token }).then(
              () => {
                resolve();
                this.handleOnCancelConfirmDialog();
                this.getHistoryOrders(true);
              },
              () => {
                reject();
                this.handleOnCancelConfirmDialog();
              }
            );
          }
          break;
        case CONFIRM_DIALOG_TYPE.reload:
          reloadOrder(item.id).then(
            data => {
              if (!data.order) {
                toast.error(t("orders.REWORK_ORDER_ERROR"));
              }
              resolve();
              this.handleOnCancelConfirmDialog();
            },
            () => {
              toast.error(t("orders.REWORK_ORDER_ERROR"));
              this.handleOnCancelConfirmDialog();
            }
          );
          break;
        default:
          resolve();
          break;
      }
    });
  };

  handleOnCancelConfirmDialog = () => {
    this.setState({
      courierConfirmDialogType: null,
      showConfirmDialog: false
    });
  };

  handleOnEdit = () => {
    const { item, history } = this.props;
    if (item && item.id) {
      if (isAssistanceGroup(item.groupId)) {
        history.push(`/assistance?orderId=${item.id}`);
      } else {
        history.push(`/edit-order?orderId=${item.id}`, { prevUrl: "/orders" });
      }
    }
  };

  handleOpenAssociatePopup = () => {
    return new Promise(resolve=> {
      resolve();
      Modal.setAppElement("#root");
      this.setState({ showAssociatePopup: true });
    });
  };

  handleOnAssociateConfirm = (courierId, isExternalType, provider, isExternalAssignment) => {
    const { item, associateOrder, associateOrdersToGroup, associateOrderToExternalCycle, addOrderToExternalCycle } = this.props;
    let data = null;
    let action = null;

    if(isExternalType) {
      action = associateOrderToExternalCycle;
      data = { provider: courierId, orderIds: [item.id] };
    } else if(isExternalAssignment) {
      action = addOrderToExternalCycle;
      data = { id: provider, orderIds: [item.id] };
    } else if(courierId === NEW_ASSOCIATE_GROUP_ID) {
      action = associateOrdersToGroup;
      data = { NewGroup: true, OrderIds: [item.id] };
    } else {
      action = associateOrder;
      data = { orderId: item.id, courierId, associateMode: true };
    }

    return action(data).then(() => {
      this.setState({ showAssociatePopup: false })
    });
  };

  handleOnChangeOrderState = orderState => {
    const { item, changeOrderState, updateOrderData } = this.props;
    return changeOrderState({
      order: item,
      state: orderState
    }).then(() => {
      updateOrderData({ ...item, state: orderState });
    });
  };

  handleOnShowOrdersMore = () => {
    const { showOrdersMore } = this.state;
    this.setState({ showOrdersMore: !showOrdersMore });
  };

  handleOnEditDelivery = () => {
    const { isEditDelivery } = this.state;
    return new Promise(resolve=> {
      resolve();
      this.setState({ isEditDelivery: !isEditDelivery });
    })
  };

  handleApplyCourierDelivery = courierId => {
    const { item, sectionModel, setOrderDeliveredBy } = this.props;

    if (courierId && item.deliveryBy !== courierId) {
      setOrderDeliveredBy({
        orderId: item.id,
        courierId: courierId,
        filterOptions: sectionModel.filterOptions
      }).then(() => {
        this.setState({ isEditDelivery: false });
      });
    }
  };  

  handleOnResize = () => {
    const { item } = this.props;
    this.updateRowHeight(item.id);
  }

  getProviderById = providerId => {
    const { ordersProvider } = this.props;
    return ordersProvider.find(p => p.id === providerId) || {};
  }

  render() {
    const { item, users, orders } = this.props;
    const {
      courierConfirmDialogType,
      showConfirmDialog,
      isWithPassword,
      showAssociatePopup,
      showOrdersMore,
      isEditDelivery
    } = this.state;
    const isAssistanceOrder = isAssistanceGroup(item.groupId);
    const convertedTargetTime = getConvertedTargetTime(item);
    const isDepotMod = isDepotMode();
    return (
      <div key={`activeOrder-${item.id}`} className={classNames("activeOrder", { showMore: showOrdersMore })}>
          {!showOrdersMore && (
            <ActiveOrderInfo
              item={item}
              users={users}
              user={this.user}
              orders={orders}
              showOrdersMore={showOrdersMore}
              isEditDelivery={isEditDelivery}
              isAssistanceOrder={isAssistanceOrder}
              isDepotMode={isDepotMod}
              convertedTargetTime={convertedTargetTime}
              userInfoItem={userInfoItem}
              showConfirmDialog={showConfirmDialog}
              isWithPassword={isWithPassword}
              courierConfirmDialogType={courierConfirmDialogType}
              handleOnConfirmDialog={this.handleOnConfirmDialog}
              getOrderStatusLabeltext={this.getOrderStatusLabeltext}
              handleOnChangeOrderState={this.handleOnChangeOrderState}
              getIsShowAssociate={this.getIsShowAssociate()}
              getIsShowReady={this.getIsShowReady()}
              getIsShowPickedUp={this.getIsShowPickedUp()}
              handleOpenAssociatePopup={this.handleOpenAssociatePopup}
              handleOnShowConfirmDialog={this.handleOnShowConfirmDialog}
              handleOnCancelConfirmDialog={this.handleOnCancelConfirmDialog}
              handleOnEdit={this.handleOnEdit}
              handleOnPreviewClick={this.handleOnPreviewClick}
              handleOnShowOrdersMore={this.handleOnShowOrdersMore}
              handleApplyCourierDelivery={this.handleApplyCourierDelivery}
              handleOnEditDelivery={this.handleOnEditDelivery}
              getProviderById={this.getProviderById}
            />
          )}
          {showOrdersMore && (
            <ActiveOrderInfoMore
              item={item}
              users={users}
              user={this.user}
              showOrdersMore={showOrdersMore}
              courierConfirmDialogType={courierConfirmDialogType}
              isEditDelivery={isEditDelivery}
              isAssistanceOrder={isAssistanceOrder}
              isDepotMode={isDepotMod}
              isWithPassword={isWithPassword}
              orders={orders}
              userInfoItem={userInfoItem}
              showConfirmDialog={showConfirmDialog}
              getOrderStatusLabeltext={this.getOrderStatusLabeltext}
              getIsShowAssociate={this.getIsShowAssociate()}
              getIsShowReady={this.getIsShowReady()}
              getIsShowPickedUp={this.getIsShowPickedUp()}
              handleOnShowOrdersMore={this.handleOnShowOrdersMore}
              handleOnChangeOrderState={this.handleOnChangeOrderState}
              handleOpenAssociatePopup={this.handleOpenAssociatePopup}
              handleOnShowConfirmDialog={this.handleOnShowConfirmDialog}
              handleOnConfirmDialog={this.handleOnConfirmDialog}
              handleOnCancelConfirmDialog={this.handleOnCancelConfirmDialog}
              handleOnEdit={this.handleOnEdit}
              handleOnPreviewClick={this.handleOnPreviewClick}
              handleApplyCourierDelivery={this.handleApplyCourierDelivery}
              handleOnEditDelivery={this.handleOnEditDelivery}
              getProviderById={this.getProviderById}
            />
          )}
          {showAssociatePopup && (
            <AssociatePopup
              isOpen={showAssociatePopup}
              courier={this.user}
              selectedOrderIds={[item.id]}
              associateMode={true}
              isGetControlCenters={true}
              onConfirm={this.handleOnAssociateConfirm}
              onClose={() => this.setState({ showAssociatePopup: false })}
            />
          )}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    restaurant: state.restaurant.data,
    groups: state.order.data.groups || [],
    orders: state.order.data.orders || [],
    historyOrders: state.order.data.historyOrders || [],
    users: state.userModel.data || [],
    sectionItemsHeights: state.sectionsWrapperData.heights,
    ordersProvider: (state.restaurant.data && state.restaurant.data.ordersProvider) || [],
  };
};

const mapDispatchToProps = dispatch => {
  return {
    deleteOrder: data => dispatch(createAction(ORDER_DELETE, data)),
    deleteAssistanceOrder: data => dispatch(createAction(ORDER_ASSISTANCE_DELETE, data)),
    associateOrder: data => dispatch(createAction(PERFORM_ORDER_ASSOCIATING, data)),
    reloadOrder: data => dispatch(createAction(RELOAD_ORDER, data)),
    updateOrderData: data => dispatch(actionUpdateOrderData(data)),
    changeOrderState: data => dispatch(createAction(CHANGE_ORDER_STATE, data)),
    loadHistoryOrders: data => dispatch(createAction(LOAD_HISTORY_ORDERS, data)),
    addOrderToExternalCycle: data => dispatch(createAction(ADD_ORDER_TO_EXTERNAL_CYCLE, data)),
    saveSectionItemHeight: data => dispatch(actionSaveSectionItemHeight(data)),
    setSectionItemsLoading: data => dispatch(actionSetSectionItemsLoading(data)),
    setOrderDeliveredBy: data => dispatch(createAction(SET_ORDER_DELIVERED_BY, data)),
    associateOrdersToGroup: data => dispatch(createAction(NEW_GROUP_REORDER, data)),
    associateOrderToExternalCycle: data=> dispatch(createAction(ASSOCIATE_ORDER_TO_EXTERNAL_CYCLE, data))
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withTranslation()(ActiveOrder))
);
